const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8081/ASTU_JMEE_JLEE"
    : "/ASTU_JMEE_JLEE";

export default API_BASE_URL;